import { ANALYTICS_ENABLE, ANALYTICS_DISABLE } from './constants';

import { makeActionCreator } from '../../../utils/actionsUtils';

export const enableAnalytics = makeActionCreator(ANALYTICS_ENABLE);
export const disableAnalytics = makeActionCreator(ANALYTICS_DISABLE);



// WEBPACK FOOTER //
// ./src/services/google/analytics/actions.js